import useBreakpoints from "@kamae-apps/shared/Hooks/useMediaQuery"
import clsx from "clsx"
import { FC, ReactNode, useCallback, useRef, useState } from "react"
import { useModalChildrenHasScroll } from "../useModalChildrenHasScroll"
import style from "./Display.module.css"

type DisplayModalProps = {
  display: boolean
  title: string | ReactNode
  subTitle: string
  primaryButton?: ReactNode
  secondaryButton?: ReactNode
  children: ReactNode
}

export const DisplayModal: FC<DisplayModalProps> = ({
  display,
  title,
  subTitle,
  primaryButton,
  secondaryButton,
  children,
}) => {
  const { isMobile } = useBreakpoints()
  const [isChildrenScrollable, setIsChildrenScrollable] = useState(false)

  const childScrollRef = useCallback((node: HTMLDivElement) => {
    setIsChildrenScrollable(useModalChildrenHasScroll(node))
  }, [])

  return (
    <div
      className={clsx(style["modal-container"], isMobile && "overflow-y-auto")}
      data-display={display}
    >
      <div
        className={style["modal-md"]}
        onClick={e => e.stopPropagation()}
      >
        <div className={style["modal-header"]}>
          <div className={style["modal-header-content"]}>
            <div className={style["modal-header-content-title"]}>
              <h3>{title}</h3>
            </div>
            <p className={style["modal-header-content-subtitle"]}>{subTitle}</p>
          </div>
        </div>
        <div
          className={style["modal-content"]}
          ref={childScrollRef}
        >
          {children}
        </div>
        <div className={`${style["modal-footer"]} ${isChildrenScrollable ? style["modal-footer-scrolled"] : ""}`}>
          {secondaryButton}
          {primaryButton}
        </div>
      </div>
    </div>
  )
}
